import { getImage, withArtDirection } from 'gatsby-plugin-image';
export var createImageWithArtDirection = function createImageWithArtDirection(_ref) {
  var _desktopImage$localFi, _desktopImage$localFi2, _mobileImage$localFil, _mobileImage$localFil2;

  var desktopImage = _ref.desktopImage,
      mobileImage = _ref.mobileImage;
  if (!(desktopImage !== null && desktopImage !== void 0 && (_desktopImage$localFi = desktopImage.localFile) !== null && _desktopImage$localFi !== void 0 && (_desktopImage$localFi2 = _desktopImage$localFi.childImageSharp) !== null && _desktopImage$localFi2 !== void 0 && _desktopImage$localFi2.gatsbyImageData)) return undefined;
  if (!(mobileImage !== null && mobileImage !== void 0 && (_mobileImage$localFil = mobileImage.localFile) !== null && _mobileImage$localFil !== void 0 && (_mobileImage$localFil2 = _mobileImage$localFil.childImageSharp) !== null && _mobileImage$localFil2 !== void 0 && _mobileImage$localFil2.gatsbyImageData)) return desktopImage;
  var artDirectedGatsbyImageData = withArtDirection(getImage(mobileImage.localFile.childImageSharp.gatsbyImageData), [{
    image: getImage(desktopImage.localFile.childImageSharp.gatsbyImageData),
    media: '(min-width: 769px)'
  }]);
  return Object.assign({}, desktopImage, {
    localFile: Object.assign({}, desktopImage.localFile, {
      childImageSharp: Object.assign({}, desktopImage.localFile.childImageSharp, {
        gatsbyImageData: artDirectedGatsbyImageData
      })
    })
  });
};
export var getFluidObjectWithAspectRatio = function getFluidObjectWithAspectRatio(_ref2) {
  var aspectRatio = _ref2.aspectRatio,
      fluidObject = _ref2.fluidObject;

  if (fluidObject instanceof Array) {
    return fluidObject.map(function (fluidItem) {
      var _ref3;

      var fluidItemFluidObject = fluidItem;
      return Object.assign({}, fluidItem, {
        aspectRatio: (_ref3 = aspectRatio !== null && aspectRatio !== void 0 ? aspectRatio : fluidItemFluidObject === null || fluidItemFluidObject === void 0 ? void 0 : fluidItemFluidObject.aspectRatio) !== null && _ref3 !== void 0 ? _ref3 : 1
      });
    });
  } else {
    var _ref4;

    return Object.assign({}, fluidObject, {
      aspectRatio: (_ref4 = aspectRatio !== null && aspectRatio !== void 0 ? aspectRatio : fluidObject.aspectRatio) !== null && _ref4 !== void 0 ? _ref4 : 1
    });
  }
};